import { render, staticRenderFns } from "./PacoteKit.vue?vue&type=template&id=6204a090&scoped=true"
import script from "./PacoteKit.vue?vue&type=script&lang=js"
export * from "./PacoteKit.vue?vue&type=script&lang=js"
import style0 from "./PacoteKit.vue?vue&type=style&index=0&id=6204a090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204a090",
  null
  
)

export default component.exports